/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1PersonSharedMaritalStatusDropdownQueryResponse,
  GetApiV1PersonSharedMaritalStatusDropdown401,
  GetApiV1PersonSharedMaritalStatusDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedMaritalStatusDropdown.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1PersonSharedMaritalStatusDropdown } from "../../clients/personSharedController/getApiV1PersonSharedMaritalStatusDropdown.ts";

export const getApiV1PersonSharedMaritalStatusDropdownQueryKey = () =>
  [{ url: "/api/v1/person/shared/marital-status-dropdown" }] as const;

export type GetApiV1PersonSharedMaritalStatusDropdownQueryKey = ReturnType<
  typeof getApiV1PersonSharedMaritalStatusDropdownQueryKey
>;

export function getApiV1PersonSharedMaritalStatusDropdownQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1PersonSharedMaritalStatusDropdownQueryKey();
  return queryOptions<
    GetApiV1PersonSharedMaritalStatusDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedMaritalStatusDropdown401
      | GetApiV1PersonSharedMaritalStatusDropdown500
    >,
    GetApiV1PersonSharedMaritalStatusDropdownQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1PersonSharedMaritalStatusDropdown({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as opções do enumerador EMartialStatus para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de estados civis para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/marital-status-dropdown}
 */
export function useGetApiV1PersonSharedMaritalStatusDropdown<
  TData = GetApiV1PersonSharedMaritalStatusDropdownQueryResponse,
  TQueryData = GetApiV1PersonSharedMaritalStatusDropdownQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1PersonSharedMaritalStatusDropdownQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1PersonSharedMaritalStatusDropdownQueryResponse,
        ResponseErrorConfig<
          | GetApiV1PersonSharedMaritalStatusDropdown401
          | GetApiV1PersonSharedMaritalStatusDropdown500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1PersonSharedMaritalStatusDropdownQueryKey();

  const query = useQuery(
    {
      ...getApiV1PersonSharedMaritalStatusDropdownQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1PersonSharedMaritalStatusDropdown401
      | GetApiV1PersonSharedMaritalStatusDropdown500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
